import { SubscriptionService } from './../app/proxy/products/subscription.service';
import { OfferService } from './../app/proxy/products/offer.service';
import { SubscriptionFullDto, OfferFullDto } from './../app/proxy/products/models';
import { NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';
import { UserDto } from './../app/proxy/users/models';
import { OAuthService } from 'angular-oauth2-oidc';
import { UserService } from './../app/proxy/users/user.service';
import { CategoryDto } from './../app/proxy/categories/models';
import { CategoryService } from '@proxy/categories';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ListService } from '@abp/ng.core';


@Component({
  template: "",
  changeDetection: ChangeDetectionStrategy.Default,
})

export class DataStore implements OnInit {

  public currentUser: UserDto;
  public categories: CategoryDto[] = [];
  public isInitialized: boolean = false;
  public subscriptions: SubscriptionFullDto[] = [];
  public offers: OfferFullDto[] = [];

  constructor(
    private readonly categoryService: CategoryService,
    private readonly userService: UserService,
    private readonly offerService: OfferService,
    private readonly subscriptionService: SubscriptionService,
    private oAuthService: OAuthService,
  ) { }

  async ngOnInit() {
    // Only load data if user is authenticated
    if (!this.oAuthService.hasValidAccessToken()) {
      this.isInitialized = true;
      return;
    }

    // Load user profile and check if sub exists before calling userService.get()
    const userProfile = await this.oAuthService.loadUserProfile() as any;
    const userId = userProfile?.sub;

    if (userId) {
      this.userService
        .get(userId)
        .subscribe(response => (this.currentUser = response));
    } else {
      console.warn('User ID (sub) not found in OAuth profile');
    }

    this.categoryService
      .getList()
      .subscribe(response => (this.categories = response.items));
    this.isInitialized = true;

    this.offerService
      .getList()
      .subscribe(response => {
        this.offers = response.items.filter(x => x.type as any !== 'Subscription')
      })

    this.subscriptionService
      .getList()
      .subscribe(response => {
        this.subscriptions = response.items.map(x => x);
      });
  }

  updateCategories() {
    this.categoryService
      .getList()
      .subscribe(response => (this.categories = response.items));
  }
}
